import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

/**
 * 在主框架内显示
 */
const frameIn = [{
	path: '/',
	redirect: {
		name: 'index'
	},
	component: layoutHeaderAside,
	children: [
		
		{
			path: 'SaleOutInfo',
			name: 'SaleOutInfo',
			meta: {
				title: '销售备货出库单',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/SaleOutInfo/SaleOutInfo')
		},
		{
			path: 'TaskReport',
			name: 'TaskReport',
			meta: {
				title: '生产进度总览',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/TaskReport/TaskReport')
		},
		{
			path: 'CuPayInfo',
			name: 'CuPayInfo',
			meta: {
				title: '客户结算单',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/CuPayInfo/CuPayInfo')
		},
		{
			path: 'CuPayFlowReport',
			name: 'CuPayFlowReport',
			meta: {
				title: '客户应收统计',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/CuPayReport/CuPayFlowReport1')
		},
		{
			path: 'CuShouldPayInfo',
			name: 'CuShouldPayInfo',
			meta: {
				title: '客户其他款项',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/CuShouldPayInfo/CuShouldPayInfo')
		},
		{
			path: 'SaleInfo',
			name: 'SaleInfo',
			meta: {
				title: '销售单',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/SaleInfo/SaleInfo')
		},
		{
			path: 'StoreFlowReport',
			name: 'StoreFlowReport',
			meta: {
				title: '库存统计与查询',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/StoreReport/ReportNavi')
		},
		{
			path: 'TaskProduceInfo',
			name: 'TaskProduceInfo',
			meta: {
				title: '派工生产单',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/TaskProduceInfo/TaskProduceInfo')
		},
		{
			path: 'StoreInInfo',
			name: 'StoreInInfo',
			meta: {
				title: '入库单',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/StoreInInfo/StoreInInfo')
		},
		{
			path: 'StoreOutInfo',
			name: 'StoreOutInfo',
			meta: {
				title: '出库单',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/StoreOutInfo/StoreOutInfo')
		},
		{
			path: 'ProductTaskInfo',
			name: 'ProductTaskInfo',
			meta: {
				title: '生产制单',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/ProductTaskInfo/ProductTaskInfo')
		},
		{
			path: 'ToolFixInfo',
			name: 'ToolFixInfo',
			meta: {
				title: '工具报障',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/ToolFixInfo/ToolFixInfo')
		},
		{
			path: 'MachineInfo',
			name: 'MachineInfo',
			meta: {
				title: '机器档案',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/MachineInfo/MachineInfo')
		},
		{
			path: 'ToolInfo',
			name: 'ToolInfo',
			meta: {
				title: '工具档案',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/ToolInfo/ToolInfo')
		},
		{
			path: 'ItemInfo',
			name: 'ItemInfo',
			meta: {
				title: '产品档案',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/ItemInfo/ItemInfo')
		},
		{
			path: 'StoreInfo',
			name: 'StoreInfo',
			meta: {
				title: '仓库档案',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/StoreInfo/StoreInfo')
		},
		{
			path: 'CustomerInfo',
			name: 'CustomerInfo',
			meta: {
				title: '客户档案',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/CustomerInfo/CustomerInfo')
		},
		{
			path: 'DicInfo',
			name: 'DicInfo',
			meta: {
				title: '数据字典',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/DicInfo/DicInfo')
		},
		{
			path: 'NoticeInfo',
			name: 'NoticeInfo',
			meta: {
				title: '公告管理',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/NoticeInfo/NoticeInfo')
		},


		// 首页
		{
			path: 'index',
			name: 'index',
			meta: {
				auth: true
			},
			component: _import('system/index')
		},
		// 系统 前端日志
		{
			path: 'log',
			name: 'log',
			meta: {
				title: '前端日志',
				auth: true
			},
			component: _import('system/log')
		},
		// 刷新页面 必须保留
		{
			path: 'refresh',
			name: 'refresh',
			hidden: true,
			component: _import('system/function/refresh')
		},
		// 页面重定向 必须保留
		{
			path: 'redirect/:route*',
			name: 'redirect',
			hidden: true,
			component: _import('system/function/redirect')
		},
		// 下面都是我的页面：
		{
			path: 'UserInfo',
			name: 'UserInfo',
			meta: {
				title: '用户及权限',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/UserInfo/UserInfo')
		}, {
			path: 'UpdateLogInfo',
			name: 'UpdateLogInfo',
			meta: {
				title: '更新日志',
				auth: true,
				cache: true, //启动缓存
			},
			component: _import('pages/UpdateLogInfo/UpdateLogInfo')
		}
	]
}]

/**
 * 在主框架之外显示
 */
const frameOut = [
	// 登录
	{
		path: '/login',
		name: 'login',
		component: _import('system/login')
	}
]

/**
 * 错误页面
 */
const errorPage = [{
	path: '*',
	name: '404',
	component: _import('system/error/404')
}]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
	...frameIn,
	...frameOut,
	...errorPage
]
